import { Component, Input } from '@angular/core'
import { Observable } from 'rxjs/internal/Observable'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { ProviderInfo } from 'src/app/obstacle/model/provider-info.model'
import { Layers } from 'src/app/shared/layers-config/layers'

const COLLAPSED_STORAGE_KEY = 'obstacle-provider4-data-collapsed'
@Component({
  selector: 'app-obstacle-provider4-data',
  templateUrl: './obstacle-provider4-data.component.html',
  standalone: false,
})
export class ObstacleProvider4DataComponent {
  public layerIds = Layers
  public isProvider4AccidentsLayerVisible: boolean | undefined
  public isProvider4BdvVisible: boolean | undefined
  public isCollapsed = true
  @Input() providerInfo$!: Observable<ProviderInfo>

  constructor(private appState: AppStateService) {
    const layers = this.appState.getState().layers
    this.isProvider4AccidentsLayerVisible = layers?.includes(Layers.Provider4Accidents.name)
    this.isProvider4BdvVisible = layers?.includes(Layers.Provider4Bdv.name)
  }

  ngOnInit(): void {
    this.isCollapsed = this.getStoredCollapsedState()
  }

  get selectedLayerCount(): number {
    return [this.isProvider4AccidentsLayerVisible, this.isProvider4BdvVisible].filter(Boolean)
      .length
  }

  get allLayerCount(): number {
    return [this.isProvider4AccidentsLayerVisible, this.isProvider4BdvVisible].length
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed
    this.storeCollapsedState()
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.Provider4Accidents.name:
        this.isProvider4AccidentsLayerVisible = !this.isProvider4AccidentsLayerVisible
        break
      case Layers.Provider4Bdv.name:
        this.isProvider4BdvVisible = !this.isProvider4BdvVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          !layer.includes(Layers.Provider4Accidents.name) &&
          !layer.includes(Layers.Provider4Bdv.name),
      )

    if (this.isProvider4AccidentsLayerVisible) {
      layers.push(Layers.Provider4Accidents.name)
    }
    if (this.isProvider4BdvVisible) {
      layers.push(Layers.Provider4Bdv.name)
    }

    this.appState.setState(AppPaths.Obstacle, {
      layers: layers?.toString(),
    })
  }

  private getStoredCollapsedState(): boolean {
    if (typeof localStorage === 'undefined') {
      return true
    }

    const storedState = localStorage.getItem(COLLAPSED_STORAGE_KEY)

    if (storedState === null) {
      return true
    }

    return storedState === 'true'
  }

  private storeCollapsedState(): void {
    if (typeof localStorage === 'undefined') {
      return
    }

    localStorage.setItem(COLLAPSED_STORAGE_KEY, String(this.isCollapsed))
  }
}
